import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { QueryClient } from '@tanstack/react-query';

// Router context type - follows TanStack Router auth integration pattern
export interface AppRouterContext {
  auth: {
    isAuthenticated: boolean;
    user: AccountInfo | null;
    isLoading: boolean;
    login: () => Promise<void>;
    logout: () => Promise<void>;
    msalInstance: IPublicClientApplication;
  };
  queryClient: QueryClient;
}

// Create router singleton
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  context: undefined!, // Context will be provided by RouterProvider
});

/**
 * Register router for type safety
 */
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}